import { clsx } from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { RoundButton } from "../../../ui/Button/Button";
import { CrossIcon } from "../../../ui/icons/CrossIcon";
import { TireLinkLogo } from "../../TireLinkLogo/TireLinkLogo";

type DealerOrderModalHeaderProps = {
  close: VoidFunction;
};

export const DealerOrderModalHeader: FunctionComponent<
  DealerOrderModalHeaderProps
> = ({ close }) => {
  const { t } = useTranslation();
  return (
    <header className="flex items-center gap-2 md:gap-6 lg:gap-8 justify-between">
      <TireLinkLogo className="h-8 -mt-2" />
      <div
        className={clsx(
          "bg-primary flex items-center justify-between rounded-button-group text-paper",
          "pl-2 md:pl-4 flex-1"
        )}
      >
        {t("dealerOrderModal.orderPreview")}
        <RoundButton aria-label="closesOrderDialog" onClick={close}>
          <CrossIcon />
        </RoundButton>
      </div>
    </header>
  );
};
